import { Typography } from '@mui/material'
import Link from './Link'

const Error = ({ error, message }) => {
  const displayedMessage =
    message ||
    (error.message === 'Network Error' &&
      'Your network connection failed. Please try again or contact Awa for help.') ||
    error?.response?.data?.message ||
    'Something went wrong. Please contact Awa for help.'

  return (
    <>
      <Typography paragraph>{displayedMessage}</Typography>
      <Typography>
        <Link href="mailto:support@awa.kiwi">support@awa.kiwi</Link>
      </Typography>
    </>
  )
}

export default Error
